export default __webpack_public_path__ + "static/media/Events.f3c0b5b5.svg";